export function getWeglotLanguage() {
  const url = new URL(window.location.href);
  const urlParts = url.pathname.split('/');
  const lang = urlParts[1];

  // Supported languages
  const supportedLanguages = ['fr', 'en', 'it', 'de'];

  // If the first part of the URL is valid, return it; otherwise default to 'de'
  return supportedLanguages.includes(lang) ? lang : 'de';
}